<template>
  <div class="container">
    <Modal
      width="600"
      v-model="showModal"
      :loading="loading"
      @on-cancel="clear"
      title="投放数据"
      @on-ok="editData"
    >
    <DatePicker type="daterange" v-model="timer" @on-change="timerChange" placement="bottom-end" placeholder="请开始选择日期" style="width: 200px;margin-bottom:20px;" />
    <Table :loading="tableLoading" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
    <Page v-show="total > 10" show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    </Modal>
  </div>
</template>

<script>
// import { util } from 'vue/types/umd'
import https from '../../https'
// import util from '../../utils'
export default {
  name: 'grayModal',
  data () {
    return {
      showModal: false,
      tableLoading: true,
      loading: false,
      timer: '',
      createTime_begin: '',
      createTime_end: '',
      columns: [
        {
          title: '日期',
          align: 'center',
          key: 'dateStr'
        },
        {
          title: '投放数',
          align: 'center',
          key: 'requestCount'
        },
        {
          title: '到达数',
          align: 'center',
          key: 'reachCount'
        },
        {
          title: '到达率',
          align: 'center',
          key: 'ratio',
          render: (h, params) => {
            let status = params.row.ratio + '%'
            let html = [
              h('span', status)
            ]
            return html
          }
        }
      ],
      url: {
        getList: 'extscreenapi/plugin/hili/grayRequestData/list'
      },
      id: '',
      dataList: [],
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1 // 当前页
    }
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.token = https.token
  },
  mounted () {
  },
  methods: {
    // 加载tabs列表
    loadData () {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.current,
        dataId: this.id,
        createTime_begin: this.createTime_begin,
        createTime_end: this.createTime_end
      }
      https.request({
        method: 'get',
        url: this.url.getList,
        params: params
      }).then(res => {
        this.tableLoading = false
        this.dataList = res.result.records
        this.total = res.result.total
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    timerChange (a) {
      this.createTime_begin = a[0]
      this.createTime_end = a[1]
      this.loadData()
    },
    clear () {
      this.showModal = false
    },
    editData () {
    },
    show (id) {
      this.id = id
      this.showModal = true
      this.loadData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/global/grayTableModal.vue